import React from 'react';
import StatisticContainer from '@src/containers/Statistic';

const Statistic = () => <StatisticContainer />;

export default Statistic;
